import {
  MyQuestNavigationMenu,
  MyQuestNavigationMenuDisplayList,
  MyQuestNavigationMenuPath,
  MyQuestNavigationMenuText,
} from '@diritto/common/navigation/constant';
import styled from '@emotion/styled';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { SubMenu } from 'ui-components/navigations/SubMenu';

export const MyQuestNavigationBar = ({ selectedMenu }: { selectedMenu: MyQuestNavigationMenu }) => (
  <StyledContainer>
    <StyledSubMenu
      menuList={MyQuestNavigationMenuDisplayList}
      menuPath={MyQuestNavigationMenuPath}
      menuText={MyQuestNavigationMenuText}
      selectedMenu={selectedMenu}
    />
  </StyledContainer>
);

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(SubMenu)`
  position: relative;
  top: 0;
  left: 0;
`;
